export const typeOfPAF = {
  MALE: 0,
  WOMANOFCP: 1,
  WOMANOFNCP: 2,
  WOMANOFCPRENEW2: 3,
};
